import {CompetitorStatus} from "./competitor";

export class CompetitorFilter {
  eventId?: number;
  raceId?: number;
  categories?: number[];
  name?: string;
  gender?: number;
  competitorStatuses?: CompetitorStatus[];
  status?: number;
}
